export default __webpack_public_path__ + "static/media/placeholder-league-thumbnail.de9fe2c4.svg";